import { postSeedingProposalRejectService } from '@musinsa/services-curator';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { curatorQueries } from '../../query-factory';

interface UseSeedingProposalMutationProps {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
}

interface RejectMutationVariables {
  participationId: number;
  rejectionReasonCodes: string[];
}

export const useSeedingProposalRejectMutation = ({
  onSuccess,
  onError,
}: UseSeedingProposalMutationProps = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ participationId, rejectionReasonCodes }: RejectMutationVariables) =>
      postSeedingProposalRejectService({ participationId, rejectionReasonCodes }),
    meta: { skipGlobalErrorHandler: true },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: curatorQueries.campaigns._def });
      onSuccess?.();
    },
    onError: (error) => onError?.(error),
  });
};
